var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-card", [
    _c(
      "div",
      { staticClass: "clearfix", attrs: { slot: "header" }, slot: "header" },
      [
        _c("span", { staticClass: "header-item" }, [_vm._v("Linked Devices")]),
        _vm._v(" "),
        _c(
          "span",
          { staticClass: "ring-card__header-buttons" },
          [
            _c("RefreshButton", {
              nativeOn: {
                click: function ($event) {
                  return _vm.fetchLinkedDevices.apply(null, arguments)
                },
              },
            }),
          ],
          1
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.loading,
            expression: "loading",
          },
        ],
        staticClass: "card-content",
      },
      [
        _c(
          "el-table",
          {
            staticStyle: { width: "100%" },
            attrs: { data: _vm.data, stripe: "" },
          },
          [
            _c("el-table-column", {
              attrs: { prop: "description", label: "Description" },
            }),
            _vm._v(" "),
            _c("el-table-column", { attrs: { prop: "kind", label: "Type" } }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { width: "180", label: "Call Alerts" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      !scope.row.kind.includes("cam")
                        ? _c("el-switch", {
                            attrs: { disabled: "true" },
                            model: {
                              value: scope.row["call_alerts"],
                              callback: function ($$v) {
                                _vm.$set(scope.row, "call_alerts", $$v)
                              },
                              expression: "scope.row['call_alerts']",
                            },
                          })
                        : _vm._e(),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { width: "180", label: "Motion Alerts" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("el-switch", {
                        attrs: { disabled: "true" },
                        model: {
                          value: scope.row["motion_alerts"],
                          callback: function ($$v) {
                            _vm.$set(scope.row, "motion_alerts", $$v)
                          },
                          expression: "scope.row['motion_alerts']",
                        },
                      }),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }